import PropTypes from 'prop-types';
import {
  phoneSmall,
  phoneLarge,
  tabletSmall,
  tabletLarge,
  desktopSmall,
  desktopMedium,
  desktopLarge,
} from 'constants/variables';

const responsive = breakpoint => {
  let queryBreakpoint;

  switch (breakpoint) {
    case 'phoneSmall':
      queryBreakpoint = phoneSmall;
      break;
    case 'phoneLarge':
      queryBreakpoint = phoneLarge;
      break;
    case 'tabletSmall':
      queryBreakpoint = tabletSmall;
      break;
    case 'tabletLarge':
      queryBreakpoint = tabletLarge;
      break;
    case 'desktopSmall':
      queryBreakpoint = desktopSmall;
      break;
    case 'desktopMedium':
      queryBreakpoint = desktopMedium;
      break;
    case 'desktopLarge':
      queryBreakpoint = desktopLarge;
      break;
    default:
  }

  return `@media only screen and (min-width: ${queryBreakpoint})`;
};

responsive.propTypes = {
  breakpoint: PropTypes.string.isRequired,
};

export default responsive;
